'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ProfileView: {
        displayName: 'ProfileView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/Profile/default/ProfileView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ProfileView = _wrapComponent('ProfileView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(ProfileView, _Component);

    function ProfileView() {
        (0, _classCallCheck3.default)(this, ProfileView);
        return (0, _possibleConstructorReturn3.default)(this, (ProfileView.__proto__ || (0, _getPrototypeOf2.default)(ProfileView)).apply(this, arguments));
    }

    (0, _createClass3.default)(ProfileView, [{
        key: 'render',
        value: function render() {
            return _react3.default.createElement(_components2.UserProfile, this.props);
        }
    }]);
    return ProfileView;
}(_react2.Component), _class.propTypes = {
    acceptValue: _react2.PropTypes.func.isRequired,
    activeField: _react2.PropTypes.func.isRequired,
    changeField: _react2.PropTypes.func.isRequired,
    changePassword: _react2.PropTypes.func.isRequired,
    confirmMail: _react2.PropTypes.func.isRequired,
    confirmPhone: _react2.PropTypes.func.isRequired,
    lang: _react2.PropTypes.object.isRequired,
    profile: _react2.PropTypes.object.isRequired,
    resetField: _react2.PropTypes.func.isRequired,
    setting: _react2.PropTypes.object.isRequired,
    user: _react2.PropTypes.object,
    currency: _react2.PropTypes.object.isRequired
}, _temp));

exports.default = ProfileView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/Profile/default/ProfileView.jsx
// module id = 1835
// module chunks = 0